/**
 * useLiveSessionsListData — fetch / refresh for the live-sessions list.
 *
 * Owns apiRequest for getAllMyNextLiveSessions / AsParent. Mapping lives in the view-model.
 * Also clears the send-tutor-message form store on mount (legacy parity).
 */
import { useCallback, useEffect } from "react"
import { useDispatch } from "react-redux"

import { apiRequest } from "../../../../../../data/redux/actions/api"
import { resetUploadedFiles } from "../../../../../../data/redux/actions/formData"
import { formIds } from "../../../../../../data/constants/formConstants"
import { liveService } from "../../../../../../data/services/liveService"

export function useLiveSessionsListData(studentEmail: string | null | undefined) {
    const dispatch = useDispatch()

    const fetchSessions = useCallback(() => {
        if (studentEmail) {
            dispatch(
                apiRequest(
                    liveService.getAllMyNextLiveSessionsAsParent,
                    {},
                    {},
                    { student_email: studentEmail }
                ) as never
            )
            return
        }
        dispatch(apiRequest(liveService.getAllMyNextLiveSessions, {}, {}, {}) as never)
    }, [dispatch, studentEmail])

    useEffect(() => {
        fetchSessions()
    }, [fetchSessions])

    // Legacy LiveSessionsListScreen clears SEND_TUTOR_MESSAGE uploads on enter.
    useEffect(() => {
        dispatch(resetUploadedFiles(formIds.SEND_TUTOR_MESSAGE) as never)
    }, [dispatch])

    return {
        refresh: fetchSessions,
    }
}
